import { jsx as t } from "@emotion/react/jsx-runtime";
import { cloneElement as i } from "react";
import { FooterWithHeaderContainer as d, FooterWithoutHeaderContainer as m } from "./DialogFooter.styled.js";
const a = ({
  actions: e,
  hasHeader: n
}) => !e || e.length === 0 ? /* @__PURE__ */ t("div", { style: {
  paddingTop: "8px"
} }) : n ? /* @__PURE__ */ t(d, { direction: "row", children: e.map((r, o) => i(r, {
  key: o
})) }) : /* @__PURE__ */ t(m, { direction: "row", justifyContent: "flex-end", children: e.map((r, o) => i(r, {
  key: o
})) });
export {
  a as DialogFooter
};
